export const POZI_HOMEPAGE_URL = 'https://pozi.com'
export const POZI_PROXY_URL = 'https://proxy.pozi.com/'

// Projection constants
export const DEFAULT_PROJECTION_CODE = 'EPSG:4326'
export const WEB_MERCATOR_PROJECTION_CODE = 'EPSG:3857'
